// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Gatsby from "gatsby";
import * as ReactHelmet from "react-helmet";

import  {graphql}  from "gatsby"
;

function Seo(Props) {
  var description = Props.description;
  var langOpt = Props.lang;
  var metaOpt = Props.meta;
  var title = Props.title;
  var lang = langOpt !== undefined ? langOpt : "en";
  var meta = metaOpt !== undefined ? metaOpt : /* [] */0;
  var data = Gatsby.useStaticQuery((graphql`
            query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `));
  var siteMetadata = data.site.siteMetadata;
  var metaDescription = description !== undefined ? description : siteMetadata.description;
  var titleTemplate = "%s | " + siteMetadata.title;
  var htmlAttributes = {
    lang: lang
  };
  var metaTagsFun = ((siteMetadata, title, metaDescription, meta) =>
      [
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta));
  return React.createElement(ReactHelmet.default, {
              title: title,
              titleTemplate: titleTemplate,
              htmlAttributes: htmlAttributes,
              meta: metaTagsFun(siteMetadata, title, metaDescription, meta)
            });
}

Seo.displayName = "SEO";

var Helmet;

var make = Seo;

var $$default = Seo;

export {
  Helmet ,
  make ,
  $$default ,
  $$default as default,
  
}
/*  Not a pure module */
